import {post} from '../utils/ajaxHelper';

function getTranslatedReviews({reviews}) {
    const url = `/pdp/translateReviews`;
    const variant = window && window.debugLog && window.debugLog.variant;
    const requestMarker = window && window.debugLog && window.debugLog.requestMarker;

    return post(url, {reviews, variant, requestMarker});
}

export default getTranslatedReviews;
export {getTranslatedReviews};
